webpackJsonp([92],{

/***/ 1291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_login_vue__ = __webpack_require__(1944);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f03b978_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_login_vue__ = __webpack_require__(2466);
function injectStyle (ssrContext) {
  __webpack_require__(2464)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f03b978"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f03b978_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_helper__ = __webpack_require__(39);




var tokenVerification = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(token) {
		var headers;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						headers = {
							Authorization: 'Bearer ' + token
						};
						_context.prev = 1;
						_context.next = 4;
						return this.$httpAcl.post('confirm/email', null, { headers: headers });

					case 4:
						this.showNotification('Su cuenta ha sido activada');
						_context.next = 10;
						break;

					case 7:
						_context.prev = 7;
						_context.t0 = _context['catch'](1);

						if (_context.t0.status === 500) {
							this.showGenericError();
						} else if (_context.t0.status === 401) {
							if (_context.t0.data.message === 'TOKEN_HAS_EXPIRED') {
								this.showGenericError('El enlace ha expirado. Se le ha enviado un nuevo enlace al correo.');
							}
						}

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 7]]);
	}));

	return function tokenVerification(_x) {
		return _ref.apply(this, arguments);
	};
}();

var signin = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var surveyId, userData, response, user, inLocalStorage, token, codeProject, codeUser;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						surveyId = getLocalData('surveyId');

						window.localStorage.clear();
						this.isLoading = true;
						userData = {
							email: this.user,
							password: this.password,
							codeApp: 'praktiko-admin'
						};
						_context2.prev = 4;
						_context2.next = 7;
						return this.$httpAcl.post('authenticate', userData);

					case 7:
						response = _context2.sent;
						user = response.data;
						inLocalStorage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user);
						token = user.token, codeProject = user.codeProject, codeUser = user.codeUser;

						localStorage.setItem("praktiko" + '::token', token);
						this.$store.dispatch('setToken', token);
						if (surveyId) {
							localStorage.setItem("praktiko" + '::surveyId', surveyId);
						}
						localStorage.setItem("praktiko", inLocalStorage);
						localStorage.setItem("praktiko" + '::codeProject', codeProject);
						localStorage.setItem("praktiko" + '::codeUser', codeUser);
						this.getUserData();
						_context2.next = 23;
						break;

					case 20:
						_context2.prev = 20;
						_context2.t0 = _context2['catch'](4);

						this.$store.dispatch('showSnackBar', {
							text: 'Sus credenciales no son válidas',
							color: 'error'
						});

					case 23:
						_context2.prev = 23;

						this.isLoading = false;
						return _context2.finish(23);

					case 26:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[4, 20, 23, 26]]);
	}));

	return function signin() {
		return _ref2.apply(this, arguments);
	};
}();

var getUserData = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var surveyId, _ref4, response, responseString;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						surveyId = getLocalData('surveyId');
						_context3.prev = 1;
						_context3.next = 4;
						return this.$httpPraktiko.get('employee/current');

					case 4:
						_ref4 = _context3.sent;
						response = _ref4.data;
						responseString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response);

						localStorage.setItem("praktiko" + '::praktiko-user', responseString);
						this.$store.dispatch('setUser', response);
						/* eslint-disable */
						if (Number(response.flagAdmin) !== 1) {
							if (response.role.code === 'RECRUITMENT') {
								this.goTo('list-process-recruitment');
							} else if (response.role.code === 'COLAB PUESTOS') {
								this.goTo('new-profile');
							} else {
								if (surveyId) {
									this.goTo('page-polls', { params: { id: surveyId } });
								} else {
									this.goTo('survey');
								}
							}
						} else {
							if (response.role.code === 'RECRUITMENT') {
								this.goTo('list-process-recruitment');
							} else if (response.role.code === 'COLAB PUESTOS') {
								this.goTo('new-profile');
							} else {
								this.goTo('working-environment');
							}
						}
						/* eslint-enable */
						_context3.next = 15;
						break;

					case 12:
						_context3.prev = 12;
						_context3.t0 = _context3['catch'](1);

						if (_context3.t0.status === 500) {
							this.showGenericError();
						}

					case 15:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[1, 12]]);
	}));

	return function getUserData() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var getLocalData = __WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].getLocalData;


function created() {
	var token = this.$route.params.token;

	if (token) {
		this.tokenVerification(token);
	}
}

function loginLogo() {
	return 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-praktico-login.png';
}

function data() {
	return {
		companyBgUrl: '/static/img/login/background-praktiko.jpg',
		companyLoginLogo: Object({"NODE_ENV":"production","APP_CODE":'praktiko-admin',"APP_NAME":'"praktiko"',"PRAKTIKO_URL":'https://temp-praktiko.apprunn.net/',"MOCK_URL":'undefined',"ACL_URL":'https://temp-acl-praktiko.apprunn.net/api',"STORAGE_USER_KEY":"praktiko","S3_IMAGES_URL":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos',"COMPANY_LOGIN_TITLE":'Praktiko',"POLL_ENGINE":'https://temp-pollengine.apprunn.net/',"UPLOAD_URL":'undefined',"COMPANY_LOGO_SMALL":'undefined',"COMPANY_LOGO":'undefined',"COLORS":'{"sidebar": "#efefef","primary": "#55ac4b","secondary": "#f09c2b","success": "#5ed52b","white": "#ffffff","gray": "#e9e9e9","info": "#606560","accent": "#005CAF","error": "#f42b17","warning": "#FFB74C"}',"LOGO_LOGIN":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-praktico-login.png',"LOGO_SMALL":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-small.png',"LOGO":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-praktiko-slider.png',"CREDENTIAL_SCRAPER":'http://34.204.114.234:8080/'}).COMPANY_LOGIN_LOGO,
		isLoading: false,
		password: '',
		showPass: false,
		user: ''
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-login',
	computed: {
		loginLogo: loginLogo
	},
	created: created,
	data: data,
	methods: {
		getUserData: getUserData,
		signin: signin,
		tokenVerification: tokenVerification
	}
});

/***/ }),

/***/ 2464:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2465);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("57377c14", content, true, {});

/***/ }),

/***/ 2465:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.text-password[data-v-5f03b978]{border-style:none;font-size:14px;margin-top:20.5px;text-align:center;text-decoration:none!important}.main-login[data-v-5f03b978]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:distribute;justify-content:space-around;background-position:50%;background-repeat:no-repeat;background-size:cover;height:100vh}.main-login .login[data-v-5f03b978]{left:150px;position:absolute;text-align:center;width:315px;z-index:5}.main-login .login .login-logo[data-v-5f03b978]{margin-bottom:91px}.main-login .login .login-logo img[data-v-5f03b978]{width:100%;height:auto}.main-login .login .login-header[data-v-5f03b978]{color:#fff;margin:0 auto 54px;width:314px}.main-login .login .login-inputs[data-v-5f03b978]{font-size:24px;margin-bottom:30px;position:relative;width:100%}.main-login .login .login-inputs .login-inputs-txt[data-v-5f03b978]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.main-login .login .login-inputs .login-inputs-txt .login-inputs-group[data-v-5f03b978]{width:90%}.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-input[data-v-5f03b978]{color:#fff;height:60px;outline:none;width:100%}.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-error-message[data-v-5f03b978]{font-size:12px;float:left}.main-login .login .login-inputs .login-spacer[data-v-5f03b978]{border:1px solid;opacity:.7;width:100%}.main-login .login .login-footer[data-v-5f03b978]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:distribute;justify-content:space-around}.main-login .login .login-footer .login-btn[data-v-5f03b978]{border-radius:100px;color:#fff!important;height:48px;line-height:48px;margin:auto;text-align:center;width:280px;outline:none}.main-login .login .login-footer .login-btn[data-v-5f03b978]:active{-webkit-transform:scale(.9);transform:scale(.9);font-size:18px!important}.main-login .login .login-footer .disabled[data-v-5f03b978]{background-color:#fff;border-radius:100px;color:#37abd0!important;height:48px;line-height:48px;margin:auto;text-align:center;width:280px}.main-login .login-info .login-info-text[data-v-5f03b978]{color:#fff;margin-bottom:30px}.main-login .login-info .login-info-btn[data-v-5f03b978]{border-radius:5px;color:#fff!important;font-size:16px;height:45px;line-height:45px;margin:auto;text-align:center;width:127px;cursor:pointer;display:block;text-decoration:none!important}.main-login .login-info .login-info-btn[data-v-5f03b978]:active{-webkit-transform:scale(.9);transform:scale(.9)}@-webkit-keyframes autofill-data-v-5f03b978{to{color:#fff;background:transparent}}@keyframes autofill-data-v-5f03b978{to{color:#fff;background:transparent}}input[data-v-5f03b978]:-webkit-autofill{-webkit-animation-name:autofill-data-v-5f03b978;animation-name:autofill-data-v-5f03b978;-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:transparent!important}.background-opacity[data-v-5f03b978]{background-image:linear-gradient(280deg,hsla(0,0%,100%,.41),hsla(0,0%,100%,.96) 76%,hsla(0,0%,100%,.96));bottom:0;left:0;position:absolute;right:0;top:0}.icon-eyes[data-v-5f03b978]{position:absolute;top:70px;right:20px}", "", {"version":3,"sources":["/opt/build/repo/src/pages/page-login.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,gCACE,kBAAmB,AACnB,eAAgB,AAChB,kBAAmB,AACnB,kBAAmB,AACnB,8BAAiC,CAClC,AACD,6BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,6BAA8B,AAClC,wBAA4B,AAC5B,4BAA6B,AAC7B,sBAAuB,AACvB,YAAc,CACf,AACD,oCACI,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,YAAa,AACb,SAAW,CACd,AACD,gDACM,kBAAoB,CACzB,AACD,oDACM,WAAY,AACZ,WAAa,CAClB,AACD,kDACM,WAAe,AACf,mBAAoB,AACpB,WAAa,CAClB,AACD,kDACM,eAAgB,AAChB,mBAAoB,AACpB,kBAAmB,AACnB,UAAY,CACjB,AACD,oEACQ,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC9C,AACD,wFACU,SAAW,CACpB,AACD,qGACY,WAAe,AACf,YAAa,AACb,aAAc,AACd,UAAY,CACvB,AACD,6GACY,eAAgB,AAChB,UAAY,CACvB,AACD,gEACQ,iBAAkB,AAClB,WAAa,AACb,UAAY,CACnB,AACD,kDACM,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,4BAA8B,CACvC,AACD,6DACQ,oBAAqB,AACrB,qBAAwB,AACxB,YAAa,AACb,iBAAkB,AAClB,YAAa,AACb,kBAAmB,AACnB,YAAa,AACb,YAAc,CACrB,AACD,oEACQ,4BAA8B,AACtB,oBAAsB,AAC9B,wBAA2B,CAClC,AACD,4DACQ,sBAA0B,AAC1B,oBAAqB,AACrB,wBAA0B,AAC1B,YAAa,AACb,iBAAkB,AAClB,YAAa,AACb,kBAAmB,AACnB,WAAa,CACpB,AACD,0DACI,WAAe,AACf,kBAAoB,CACvB,AACD,yDACI,kBAAmB,AACnB,qBAAwB,AACxB,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,YAAa,AACb,kBAAmB,AACnB,YAAa,AACb,eAAgB,AAChB,cAAe,AACf,8BAAiC,CACpC,AACD,gEACI,4BAA8B,AACtB,mBAAsB,CACjC,AACD,4CACA,GACI,WAAa,AACb,sBAAwB,CAC3B,CACA,AACD,oCACA,GACI,WAAa,AACb,sBAAwB,CAC3B,CACA,AACD,wCACE,gDAAiD,AACzC,wCAAyC,AACjD,iCAAkC,AAC1B,yBAA0B,AAClC,sCAAyC,CAC1C,AACD,qCACE,yGAA+H,AAC/H,SAAU,AACV,OAAQ,AACR,kBAAmB,AACnB,QAAS,AACT,KAAO,CACR,AACD,4BACE,kBAAmB,AACnB,SAAU,AACV,UAAY,CACb","file":"page-login.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.text-password[data-v-5f03b978] {\n  border-style: none;\n  font-size: 14px;\n  margin-top: 20.5px;\n  text-align: center;\n  text-decoration: none !important;\n}\n.main-login[data-v-5f03b978] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n}\n.main-login .login[data-v-5f03b978] {\n    left: 150px;\n    position: absolute;\n    text-align: center;\n    width: 315px;\n    z-index: 5;\n}\n.main-login .login .login-logo[data-v-5f03b978] {\n      margin-bottom: 91px;\n}\n.main-login .login .login-logo img[data-v-5f03b978] {\n      width: 100%;\n      height: auto;\n}\n.main-login .login .login-header[data-v-5f03b978] {\n      color: #ffffff;\n      margin: 0 auto 54px;\n      width: 314px;\n}\n.main-login .login .login-inputs[data-v-5f03b978] {\n      font-size: 24px;\n      margin-bottom: 30px;\n      position: relative;\n      width: 100%;\n}\n.main-login .login .login-inputs .login-inputs-txt[data-v-5f03b978] {\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n}\n.main-login .login .login-inputs .login-inputs-txt .login-inputs-group[data-v-5f03b978] {\n          width: 90%;\n}\n.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-input[data-v-5f03b978] {\n            color: #ffffff;\n            height: 60px;\n            outline: none;\n            width: 100%;\n}\n.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-error-message[data-v-5f03b978] {\n            font-size: 12px;\n            float: left;\n}\n.main-login .login .login-inputs .login-spacer[data-v-5f03b978] {\n        border: 1px solid;\n        opacity: 0.7;\n        width: 100%;\n}\n.main-login .login .login-footer[data-v-5f03b978] {\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n      -ms-flex-pack: distribute;\n          justify-content: space-around;\n}\n.main-login .login .login-footer .login-btn[data-v-5f03b978] {\n        border-radius: 100px;\n        color: white !important;\n        height: 48px;\n        line-height: 48px;\n        margin: auto;\n        text-align: center;\n        width: 280px;\n        outline: none;\n}\n.main-login .login .login-footer .login-btn[data-v-5f03b978]:active {\n        -webkit-transform: scale(0.9);\n                transform: scale(0.9);\n        font-size: 18px !important;\n}\n.main-login .login .login-footer .disabled[data-v-5f03b978] {\n        background-color: #ffffff;\n        border-radius: 100px;\n        color: #37abd0 !important;\n        height: 48px;\n        line-height: 48px;\n        margin: auto;\n        text-align: center;\n        width: 280px;\n}\n.main-login .login-info .login-info-text[data-v-5f03b978] {\n    color: #ffffff;\n    margin-bottom: 30px;\n}\n.main-login .login-info .login-info-btn[data-v-5f03b978] {\n    border-radius: 5px;\n    color: white !important;\n    font-size: 16px;\n    height: 45px;\n    line-height: 45px;\n    margin: auto;\n    text-align: center;\n    width: 127px;\n    cursor: pointer;\n    display: block;\n    text-decoration: none !important;\n}\n.main-login .login-info .login-info-btn[data-v-5f03b978]:active {\n    -webkit-transform: scale(0.9);\n            transform: scale(0.9);\n}\n@-webkit-keyframes autofill-data-v-5f03b978 {\nto {\n    color: white;\n    background: transparent;\n}\n}\n@keyframes autofill-data-v-5f03b978 {\nto {\n    color: white;\n    background: transparent;\n}\n}\ninput[data-v-5f03b978]:-webkit-autofill {\n  -webkit-animation-name: autofill-data-v-5f03b978;\n          animation-name: autofill-data-v-5f03b978;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  background-color: transparent !important;\n}\n.background-opacity[data-v-5f03b978] {\n  background-image: linear-gradient(280deg, rgba(255, 255, 255, 0.41), rgba(255, 255, 255, 0.96) 76%, rgba(255, 255, 255, 0.96));\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.icon-eyes[data-v-5f03b978] {\n  position: absolute;\n  top: 70px;\n  right: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-login',[_c('div',{staticClass:"main-login",style:(("background-image: url(" + _vm.companyBgUrl + ")"))},[_c('div',{staticClass:"background-opacity"}),_vm._v(" "),_c('section',{staticClass:"login"},[_c('div',{staticClass:"login-logo"},[_c('img',{attrs:{"src":_vm.loginLogo,"alt":"praktiko logo","height":"131","width":"345"}})]),_vm._v(" "),_c('form',{staticClass:"login-inputs",attrs:{"id":"login-form"},on:{"submit":function($event){$event.preventDefault();return _vm.signin($event)}}},[_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"login-input",attrs:{"autocomplete":"off","background-color":"transparent","box":"","height":48,"hide-details":"","placeholder":"Email/Usuario","type":"email"},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pt-2":""}},[_c('v-text-field',{staticClass:"login-input",attrs:{"box":"","autocomplete":"off","background-color":"transparent","hide-details":"","placeholder":"Contraseña","append-icon":_vm.showPass ? 'visibility' : 'visibility_off',"type":_vm.showPass ? 'text' : 'password',"height":48},on:{"click:append":function($event){_vm.showPass = !_vm.showPass}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"login-footer"},[_c('v-btn',{staticClass:"login-btn",class:{ disabled: _vm.isLoading },style:(("background-color:" + (_vm.$appColors.primary))),attrs:{"type":"submit","form":"login-form","loading":_vm.isLoading,"accesskey":"13","disabled":_vm.isLoading}},[_vm._v("\n\t\t\t\t\tIniciar Sesión\n\t\t\t\t")])],1),_vm._v(" "),_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":"/reset-password"}},[_c('p',{staticClass:"text-password",style:(("color:" + (_vm.$appColors.secondary)))},[_vm._v("\n\t\t\t\t\t¿Olvidaste tu contraseña?\n\t\t\t\t")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/92.9e9b53845a9919f659f3.js